import { cn } from '@seen/ui'
import type { JSX } from 'react'
import { NavigationMenu } from '#src/components/core/navigation-menu/NavigationMenu.tsx'
import { NavigationMenuItem } from '#src/components/core/navigation-menu/NavigationMenuItem.tsx'
import { NavigationMenuLink } from '#src/components/core/navigation-menu/NavigationMenuLink.tsx'
import { NavigationMenuList } from '#src/components/core/navigation-menu/NavigationMenuList.tsx'

export interface InboxNavigationProps {
  className?: string
}

export function InboxNavigation({
  className,
}: InboxNavigationProps): JSX.Element {
  return (
    <NavigationMenu className={className}>
      <NavigationMenuList
        className={cn(
          'gap-4 lg:gap-6',
          'ml-px' // Nudge over for visual alignment.
        )}
      >
        <NavigationMenuItem>
          <NavigationMenuLink to="/" className="block" end>
            Inbox
          </NavigationMenuLink>
        </NavigationMenuItem>
        <NavigationMenuItem>
          <NavigationMenuLink to="/inbox/done" className="block" end>
            Done
          </NavigationMenuLink>
        </NavigationMenuItem>
      </NavigationMenuList>
    </NavigationMenu>
  )
}
